<template>
	<div>
		<div class="top_bar">
			<div class="flex_common">
				<img src="../assets/logo.png" alt="logo" style="width: 36px; height: 36px" />
				<div class="web_name">林距离客服平台</div>
			</div>
			<div class="user_info">
				<div class="user_name">
					<span>{{ userName }}</span>
				</div>
				<div class="logout_btn commonflex" v-throttle="logoutFn">
					<img src="../assets/back.png" style="width: 15px; height: 15px" />
					<div style="margin-left: 5px">退出</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { post } from "../utils/request";
import { useRouter } from "vue-router";
export default {
	name: "TopBar",
	data() {
		return {
			userName: sessionStorage.getItem("nickname"),
			router: useRouter(),
		};
	},
	methods: {
		logoutFn() {
			const type = sessionStorage.getItem("down_line");
			if (type=='up') {
				this.$message({
					type: "error",
					message: "请下线后退出",
				});
				return
			}
			this.$confirm("是否要退出登录？", "提示消息", {
				confirmButtonText: "退出",
				cancelButtonText: "取消",
				type: "warning",
				closeOnClickModal: false,
			}).then(() => {
				post("/api-oauth/user/logout", {}).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "退出成功",
						});
						sessionStorage.clear();
						this.router.replace("/login");
					} else {
						this.$message({
							type: "error",
							message: "退出失败",
						});
					}
				});
			});
		},
	},
};
</script>
<style lang="less" scoped>
.top_bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 54px;
	padding: 0 20px;
	border-bottom: 1px solid #c0bcbc;
	box-sizing: border-box;
	color: #333333;
	font-size: 14px;
	.web_name {
		margin-left: 6px;
		font-weight: 500;
	}
	.user_info {
		display: flex;
		align-items: center;

		.user_name {
			margin-left: 40px;
		}
		.logout_btn {
			margin-left: 40px;
			cursor: pointer;
		}
	}
}
.commonflex {
	display: flex;
	align-items: center;
	justify-content: center;
}

.user_num {
	padding-top: 10px;
	width: 100%;
	padding-left: 44px;
	border-bottom: 1px solid #c0bcbc;
	.top_content {
		font-size: 14px;
		display: flex;
		align-items: center;
	}
	.refresh {
		margin-left: 20px;
		cursor: pointer;
		color: #007aff;
		margin-top: -2px;
	}
}
.middle_content {
	display: flex;
}
</style>
